import React from 'react';
import { TicketInfo as TicketInfoContainer, TicketTitle, TicketMeta, IconWrapper, TicketNumber, Separator, Assignee, Building, } from './styles';
export var TicketInfo = function (_a) {
    var _b;
    var ticket = _a.ticket, _c = _a.isClientView, isClientView = _c === void 0 ? false : _c;
    return (React.createElement(TicketInfoContainer, { "$isClientView": isClientView },
        React.createElement(TicketTitle, null, ticket.title),
        React.createElement(TicketMeta, null,
            React.createElement(IconWrapper, null,
                React.createElement("span", null, ticket.communicationIcon)),
            React.createElement(TicketNumber, null,
                "#",
                ticket.ticket_number),
            React.createElement(Separator, null, "|"),
            React.createElement(Assignee, null, ticket.assigneeName),
            React.createElement(Separator, null, "|"),
            React.createElement(Building, { "$isClientView": isClientView }, ((_b = ticket.building) === null || _b === void 0 ? void 0 : _b.name) || 'N/A'))));
};
